import CartPanelActiveHotelTile from './CartPanelActiveHotelTile'
import CartPanelNeedsDatesTile from './CartPanelNeedsDatesTile'
import CartPanelDurationUnavailableTile from './CartPanelDurationUnavailableTile'
import type { CartPanelAccommodationItem } from '../hooks/useCartPanelItems'
import { resolveCartPanelHotelTileKind } from '../utils/cartPanelUtils'

interface Props {
  item: CartPanelAccommodationItem
  onToggleInclude: (item: CartPanelAccommodationItem) => void
  onDelete: (item: CartPanelAccommodationItem) => void
  isStreaming: boolean
}

function CartPanelHotelTileDispatcher({
  item,
  onToggleInclude,
  onDelete,
  isStreaming,
}: Props) {
  switch (resolveCartPanelHotelTileKind(item)) {
    case 'stay':
      return (
        <CartPanelActiveHotelTile
          item={item}
          onToggleInclude={onToggleInclude}
          onDelete={onDelete}
          isStreaming={isStreaming}
        />
      )
    case 'needs_dates':
      return (
        <CartPanelNeedsDatesTile
          item={item}
          onToggleInclude={onToggleInclude}
          onDelete={onDelete}
          isStreaming={isStreaming}
        />
      )
    case 'duration_unavailable':
      return (
        <CartPanelDurationUnavailableTile
          item={item}
          onToggleInclude={onToggleInclude}
          onDelete={onDelete}
          isStreaming={isStreaming}
        />
      )
    default:
      return undefined
  }
}

export default CartPanelHotelTileDispatcher
